import { formatCurrency } from 'components/Widget/shared/currency';
import { formatDuration, SUMMARY_COPY } from './constants';
import type { LoanPanel } from './types';

interface LoanCalculatorSummaryProps {
  panel: LoanPanel;
}

/** Announcement only: the panel stays on screen, so repeating the payment in view would duplicate it. */
export const LoanCalculatorSummary = ({ panel }: LoanCalculatorSummaryProps) => (
  <p className="sr-only">
    {SUMMARY_COPY.payment(
      formatCurrency(panel.result.baseline.monthlyPayment),
      formatDuration(panel.result.baseline.monthsToPayoff),
    )}
  </p>
);
